import { LoadingDots } from '@workday/canvas-kit-react/loading-dots';
import { createStyles } from '@workday/canvas-kit-styling';
import { system } from '@workday/canvas-tokens-web';
import { useIsMounted } from '@workday/wcp-cargo-react';
import { WcpStyles } from '@workday/wcp-tokens';
import * as React from 'react';
import { useEffect, useState } from 'react';

export const THREE_DOTS_LOADER_TEST_ID = 'three-dots-loader';

interface ThreeDotsLoaderProps {
  /** Delay in ms before the loader appears — useful when requests are quick and don't warrant animation */
  delay?: number;
  inline?: boolean;
}

export const ThreeDotsLoader: React.FC<ThreeDotsLoaderProps> = ({ delay = 500, inline }) => {
  const [visible, setVisible] = useState(!delay);
  const dispatch = useIsMounted();

  useEffect(() => {
    if (delay) {
      setVisible(false);
      setTimeout(() => {
        dispatch(() => setVisible(true));
      }, delay);
    }
  }, [delay]);

  const loader = (
    <LoadingDots
      data-testid={THREE_DOTS_LOADER_TEST_ID}
      loadingDotColor={WcpStyles.color.fg.muted.strong}
      className={centerStyles}
    />
  );

  return visible && (inline ? <div className={inlineWrapperStyles}>{loader}</div> : loader);
};

const centerStyles = createStyles({
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
});

const inlineWrapperStyles = createStyles({
  position: 'relative',
  paddingTop: system.space.x6,
  height: '3rem',
});

export const ThreeDotsAppLoader: React.FC = () => <ThreeDotsLoader delay={1000} />;
